export interface Timed {
    startTime: number;
    endTime: number;
}

export const findActiveIndex = (segments: readonly Timed[], time: number): number => {
    let low = 0;
    let high = segments.length - 1;
    let found = -1;
    while (low <= high) {
        const middle = (low + high) >> 1;
        if (segments[middle].startTime <= time) {
            found = middle;
            low = middle + 1;
        } else {
            high = middle - 1;
        }
    }
    return found;
};

export const findSegmentIndexById = (segments: readonly {segmentId: number}[], segmentId: number): number =>
    segments.findIndex((segment) => segment.segmentId === segmentId);
